<template>
	<div class="manage-event-dialog">
		<h2>Gestisci Evento</h2>

		<div class="summary">
			<div class="date">
				<div class="day">{{ event.start.dateTime | moment('D') }}</div>
				<div class="month">{{ event.start.dateTime | moment('MMM') }}</div>
			</div>

			<h1 class="name">{{ event.summary }}</h1>
		</div>

		<div class="subs" v-if="true">
			<div v-for="sub in enrolled" :key="sub.user.id"
				class="sub" :class="{'guest': sub.user.guest}" :title="sub.user.first_name + ' ' + sub.user.last_name" @click="removeSub(sub)">
				<img :src="'https://ui-avatars.com/api/?name=' + sub.user.first_name + '+' + sub.user.last_name + '&size=64'"/>
			</div>

			<div v-for="i in 12 - enrolled.length" :key="'empty-' + i"
				class="empty-sub"
				@click="subGuest"></div>
			
			<div v-for="sub in dropped" :key="sub.user.id"
				class="sub dropped" :title="sub.user.first_name + ' ' + sub.user.last_name" @click="removeSub(sub)">
				<img :src="'https://ui-avatars.com/api/?name=' + sub.user.first_name + '+' + sub.user.last_name + '&size=64'"/>
			</div>
			<div v-for="sub in dropped2" :key="sub.user.id"
				class="sub dropped2" :title="sub.user.first_name + ' ' + sub.user.last_name" @click="removeSub(sub)">
				<img :src="'https://ui-avatars.com/api/?name=' + sub.user.first_name + '+' + sub.user.last_name + '&size=64'"/>
			</div>
		</div>
		
		<div class="loading" v-else>
			<LoadingWidget/>
		</div>

		<create-guest @sub="subGuest"></create-guest>
	</div>
</template>

<script>
import api from '@/api'
import { notif, pop } from '@/pop'

export default {
	name: 'manage-event-dialog',

	components: {
		CreateGuest: () => import("./CreateGuest.vue")
	},

	props: {
		event: {
			type: Object,
			required: true
		}
	},

	computed: {
		/**
		 * 
		 */
		dropped() {

			return (this.event.subs || []).filter(({ b_dropped }) => b_dropped)
		},

		/**
		 * 
		 */
		dropped2() {

			return (this.event.subs || []).filter(({ b_dropped2 }) => b_dropped2)
		},

		/**
		 * 
		 */
		enrolled() {
			
			return (this.event.subs || []).filter(({ b_dropped, b_dropped2 }) => !b_dropped && !b_dropped2)
		}

	},

	methods: {
		/**
		 * 
		 */
		async subGuest(data) {

			try
			{
				// Push sub
				let sub = await api.admin().subGuest(this.event.id, data)
				this.$emit('sub', sub)

				notif.done('Ospite aggiunto')
			}
			catch (err)
			{
				console.error(err.dev_msg || String(err))
				notif.error('Errore, riprova più tardi')
			}
		},

		/**
		 *
		 */
		async removeSub(sub)
		{
			try
			{
				// Remove sub
				await api.admin().removeSub(this.event.id, sub.user.id)
				this.$emit('unsub', sub)

				notif.done('Prenotazione cancellata')
			}
			catch (err)
			{
				console.error(err.dev_msg || String(err))
				notif.err('Errore, riprova più tardi (Lazzo culo!)')
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.manage-event-dialog
	.summary
		display flex
		align-items center

		.date
			margin-right 1em
			padding 1em
			border-right 2px solid secondary

			text-align center

			.day
				color secondary

				font-size 2em
				font-weight bold
			
			.month
				text-transform uppercase
	
	.subs
		display grid
		grid-template-columns repeat(6, 1fr)
		grid-gap 1em
		justify-items center

		margin-top 2em

		.empty-sub
			width 4em
			height 4em

			position relative

			border 2px dashed light
			border-radius 50%
			box-sizing border-box

			cursor pointer

			&:before
				content '\f067'

				display block

				position absolute
				top 50%
				left 50%
				z-index 1

				font-family 'Font Awesome 5 Free'
				font-weight 900

				transform translate(-50%, -50%)
		
		.sub
			width 4em
			height 4em

			position relative

			border-radius 50%
			box-sizing border-box
			overflow hidden

			&.guest
				border 2px solid primary
			&.dropped
				border 4px solid crimson

				&:before
					content '\f12a'

					display block

					position absolute
					top 50%
					left 50%
					z-index 1

					color crimson

					font-family 'Font Awesome 5 Free'
					font-weight 900

					transform translate(-50%, -50%)

			&.dropped2
				border 4px solid green

				&:before
					content '\f12a'

					display block

					position absolute
					top 50%
					left 50%
					z-index 1

					color green

					font-family 'Font Awesome 5 Free'
					font-weight 900

					transform translate(-50%, -50%)

			img
				width 100%
				height 100%

				object-fit cover
	
	.loading
		margin-top 2em

		.loading-widget
			width 4em
			height 4em

			margin auto
</style>